import { useCallback } from 'react';
import cx from 'classnames';
import SvgIcon from '../SvgIcon';
import SVG_ICONS from '../../../../assets/icons/icons';

import './PreviewInfo.scss';

export const POSITION = { TOP: 'top', BOTTOM: 'bottom' };

const PreviewInfo = (props) => {
  const { link, title, subtitle, duration, position = POSITION.BOTTOM, onSelectorClick, children: ChildComponent, ...extraProps } = props;

  const infoCls = cx(
    'grid-image-info',
    'pb2 pt2',
    'pl3',
    'pr3',
    'absolute',
    'w-100',
    'flex',
    'content-center',
    'flex-column',
    'justify-evenly',
    'left-0',
    `${position}-0`,
    `${position === POSITION.BOTTOM ? 'slideOutDown' : 'slideOutUp'}`
  );

  const onEnlargeClick = useCallback(() => self.open(link), [link]);

  // TODO: rewrite with indexOf(".") or use a regex to find extension
  const isFile = () => link && typeof link.split('.')[1] !== 'undefined';

  const renderTileEnlarge = () => {
    if (isFile()) {
      return (
        <div data-test="preview-enlarge" className="flex-noshrink mr3 flex pointer pointer-events-all" onClick={onEnlargeClick}>
          <SvgIcon path={SVG_ICONS.OPEN_IN_NEW} size="sm" color="#FFFFFF" />
        </div>
      );
    }
  };

  const previewTitle = title && (
    <div className="img-title ellipsis w-100" onClick={onSelectorClick}>
      {title}&nbsp;
    </div>
  );
  const previewSubTitle = subtitle && (
    <div className="img-subtitle ellipsis w-100" title={subtitle}>
      {subtitle}
    </div>
  );

  const previewDuration = duration
    ? {
        seconds: duration % 60 < 10 ? `0${duration % 60}` : duration % 60,
        minutes: Math.floor(duration / 60) < 10 ? `0${Math.floor(duration / 60)}` : Math.floor(duration / 60),
      }
    : null;

  const renderDefaultLayout = () => (
    <>
      {previewDuration && (
        <div data-test="preview-duration">
          {previewDuration.minutes}:{previewDuration.seconds}
        </div>
      )}
      <div className="flex w-100 items-end">
        {renderTileEnlarge()}
        <div className="ellipsis flex-grow w-100 flex items-center" onClick={onSelectorClick}>
          {previewTitle}
          {previewSubTitle}
        </div>
      </div>
    </>
  );

  return (
    <div className="gird-image-info-container pointer-events-none">
      <div className={infoCls}>
        {ChildComponent ? (
          <ChildComponent {...extraProps} link={link} title={title} subtitle={subtitle} duration={duration} onClick={onSelectorClick} />
        ) : (
          renderDefaultLayout()
        )}
      </div>
    </div>
  );
};

export default PreviewInfo;
